import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { CONNECTED_APPS_SELECTION, LAST_CONNECTED_APPS_LIST } from '../../constants/superstoreStorageKeys';
import PortalIdParser from 'PortalIdParser';
import { getSuperStoreValue, setSuperstoreValue, deleteSuperstoreValue } from '../../utils/superStoreUtils';
const getConnectedAppsSelectionKey = () => {
  const portalId = PortalIdParser.get();
  return `${CONNECTED_APPS_SELECTION}:${portalId}`;
};
export const clearConnectedAppsSelectionFromSuperstore = async () => {
  const storageKey = getConnectedAppsSelectionKey();
  await deleteSuperstoreValue(storageKey);
};
export const saveConnectedAppsSelectionInSuperstore = async (appSearchScope, keepSelectionForFutureChats) => {
  if (keepSelectionForFutureChats) {
    const storageKey = getConnectedAppsSelectionKey();
    await setSuperstoreValue(storageKey, appSearchScope);
  } else {
    await clearConnectedAppsSelectionFromSuperstore();
  }
};
export const loadConnectedAppsSelectionFromSuperstore = async () => {
  const storageKey = getConnectedAppsSelectionKey();
  const appSearchScope = await getSuperStoreValue(storageKey);
  if (!appSearchScope) {
    return null;
  }
  if (!appSearchScope || typeof appSearchScope !== 'object' || !appSearchScope.type) {
    consoleIfNotProd.warn('Invalid connected apps selection data in superstore, clearing...');
    await clearConnectedAppsSelectionFromSuperstore();
    return null;
  }
  return appSearchScope;
};
export const updateConnectedAppsSelectionIfExists = async appSearchScope => {
  const storageKey = getConnectedAppsSelectionKey();
  const existingSelection = await getSuperStoreValue(storageKey);
  if (existingSelection) {
    await setSuperstoreValue(storageKey, appSearchScope);
    return true;
  }
  return false;
};
export const sanitizeStoredAppSelectionFromSuperstore = (storedScope, currentConnectedApps) => {
  if (storedScope.type === 'ALL_APPS') {
    return storedScope;
  }
  if (storedScope.type === 'SELECTED_APPS' && storedScope.includedApps) {
    const currentAppNames = currentConnectedApps.map(app => app.appName);
    const validIncludedApps = storedScope.includedApps.filter(appName => currentAppNames.includes(appName));
    if (validIncludedApps.length === 0) {
      return {
        type: 'SELECTED_APPS',
        includedApps: []
      };
    }
    if (validIncludedApps.length === currentConnectedApps.length) {
      return {
        type: 'ALL_APPS'
      };
    }
    return {
      type: 'SELECTED_APPS',
      includedApps: validIncludedApps
    };
  }
  return {
    type: 'SELECTED_APPS',
    includedApps: []
  };
};

// Store and retrieve last connected apps list for comparison-based new app detection
const getLastConnectedAppsListKey = () => {
  const portalId = PortalIdParser.get();
  return `${LAST_CONNECTED_APPS_LIST}:${portalId}`;
};
export const getLastConnectedAppsListFromSuperstore = async () => {
  const storageKey = getLastConnectedAppsListKey();
  const appList = await getSuperStoreValue(storageKey);
  return appList;
};
export const setLastConnectedAppsListInSuperstore = async appNames => {
  const storageKey = getLastConnectedAppsListKey();
  await setSuperstoreValue(storageKey, appNames);
};